var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Toasts")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-error'
        });
      }
    }
  }, [_vm._v("Error Toast")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-error',
          longMessage: true
        });
      }
    }
  }, [_vm._v("Error Toast - Long")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-warning'
        });
      }
    }
  }, [_vm._v("Warning Toast")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-warning',
          longMessage: true
        });
      }
    }
  }, [_vm._v(" Warning Toast - Long ")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-success'
        });
      }
    }
  }, [_vm._v("Success Toast")]), _c('button', {
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showToast({
          toastClass: 'toast-success',
          longMessage: true
        });
      }
    }
  }, [_vm._v(" Success Toast - Long ")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col my-3"
  }, [_c('h1', [_vm._v("Brand Standards")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col"
  }, [_c('h2', {
    staticClass: "my-3"
  }, [_vm._v("Typography")]), _c('div', {
    staticClass: "mt-1 row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h1', [_vm._v("H1 - 32px")]), _c('h2', [_vm._v("H2 - 24px")]), _c('h3', [_vm._v("H3 - 18px")]), _c('h4', [_vm._v("H4 - 16px")])]), _c('div', {
    staticClass: "col-3"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("P1 - 14px")]), _c('p', {
    staticClass: "p2"
  }, [_vm._v("P2 - 12px")]), _c('p', {
    staticClass: "button-text"
  }, [_vm._v("Button - 14px")]), _c('p', {
    staticClass: "overline-text"
  }, [_vm._v("Overline - 12px")]), _c('p', {
    staticClass: "tag-text"
  }, [_vm._v("Tag - 12px")])])])]);
}]

export { render, staticRenderFns }